import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:journeyId|checklistId|itemId|assignedMemberId|completedByMemberId|ownerMemberId|creatorMemberId|memberId|createdByMemberId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

/** Private Journey checklist — independent of Day/Activity / Stay / Transport. */
export const journeyChecklistApi = {
  getBoard: (journeyId) => travelClient.get(
    travelEndpoints.journeyChecklist(journeyId),
    snowflakeJson,
  ),
  createItem: (journeyId, body) => travelClient.post(
    travelEndpoints.journeyChecklistItems(journeyId),
    body,
    snowflakeJson,
  ),
  completeItem: (journeyId, itemId) => travelClient.post(
    travelEndpoints.journeyChecklistItemComplete(journeyId, itemId),
    {},
    snowflakeJson,
  ),
  reopenItem: (journeyId, itemId) => travelClient.post(
    travelEndpoints.journeyChecklistItemReopen(journeyId, itemId),
    {},
    snowflakeJson,
  ),
  reassignItem: (journeyId, itemId, assignedMemberId) => travelClient.post(
    travelEndpoints.journeyChecklistItemAssignee(journeyId, itemId),
    assignedMemberId == null || String(assignedMemberId).trim() === ''
      ? { assignedMemberId: null }
      : { assignedMemberId: String(assignedMemberId).trim() },
    snowflakeJson,
  ),
  removeItem: (journeyId, itemId, { confirm = true } = {}) => travelClient.delete(
    travelEndpoints.journeyChecklistItem(journeyId, itemId),
    { params: { confirm }, ...snowflakeJson },
  ),
};
